import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../Styles";
import { SUPPLIER_REPORT_TOC_ENTRIES } from "../../helpers/tableOfContents";
import { usePageReferences } from "../PageReference";

const TocPageNumber = ({ anchorId, isChild = false }) => {
    const pageReferences = usePageReferences();

    return (
        <Text
            style={isChild ? styles.tocChildPage : styles.tocPage}
            render={() => {
                const page = pageReferences?.current?.get(anchorId);

                return page ? `${page}` : "";
            }}
        />
    );
};

const TocRow = ({ label, anchorId, isChild = false }) => (
    <View style={isChild ? styles.tocChildRow : styles.tocRow}>
        <Text style={isChild ? styles.tocChildLabel : styles.tocLabel}>
            {label}
        </Text>

        <View style={styles.tocDots} />

        <TocPageNumber anchorId={anchorId} isChild={isChild} />
    </View>
);

const TableOfContents = ({ t, entries = SUPPLIER_REPORT_TOC_ENTRIES }) => {
    return (
        <View style={styles.tocContent}>
            <Text style={styles.tocHeading}>{t("Table of Contents")}</Text>

            <View style={styles.tocList}>
                {entries.map((entry) => {
                    const label = entry.number
                        ? `${entry.number}. ${t(entry.title)}`
                        : t(entry.title);

                    return (
                        <View key={`${entry.number || "root"}-${entry.title}`}>
                            <TocRow label={label} anchorId={entry.anchorId} />

                            {(entry.children || []).map((child) => (
                                <TocRow
                                    key={`${entry.number}-${child.number}-${child.title}`}
                                    label={`${child.number} ${t(child.title)}`}
                                    anchorId={child.anchorId}
                                    isChild
                                />
                            ))}
                        </View>
                    );
                })}
            </View>
        </View>
    );
};

export default withNamespaces()(TableOfContents);
